import React from 'react';
import { Tag } from 'tea-component';
import BubbleCommon from '@op/components/BubbleCommon';
import { getMemosByKey } from '@opm/components/BubbleCommon';
import { getMemeType, getMemeElements } from '@opm/utils/language'; 
import { MEME_ELEMENT_COLORS, MEME_TYPE_COLORS } from '../MemesTable/constants';

interface IMemeTagsCellProps {
  record: any;
  isEn: boolean;
}

function MemeTagsCell({ record = {}, isEn }: IMemeTagsCellProps) {
  const language = isEn ? "en" : "zh"; 
  const typeText = getMemeType(language, record);
  const elementText = getMemeElements(language, record);
  const typeColors =
    MEME_TYPE_COLORS[record.meme_type] || MEME_TYPE_COLORS.default;
  const elementColors =
    MEME_ELEMENT_COLORS[record.meme_elements] || MEME_ELEMENT_COLORS.default;

  return (
    <div className="dbom-meme-tags">
      {/* Type 标签 */}
      {typeText && (
        <BubbleCommon
          showIcon={false}
          tipsMap={getMemosByKey(record.meme_type, 'topic')}
        >
          <Tag
            className="dbom-meme-tag dbom-meme-tag--type"
            style={{
              backgroundColor: typeColors.backgroundColor,
              color: typeColors.color,
            }}
          >
            {typeText}
          </Tag>
        </BubbleCommon>
      )}
      {/* Element 标签 */}
      {elementText && (
        <BubbleCommon
          showIcon={false}
          tipsMap={getMemosByKey(record.meme_elements, 'content')}
        >
          <Tag
            className="dbom-meme-tag dbom-meme-tag--element"
            style={{
              backgroundColor: elementColors.backgroundColor,
              color: elementColors.color,
            }}
          >
            {elementText}
          </Tag>
        </BubbleCommon>
      )}
    </div>
  );
}

export default React.memo(MemeTagsCell);
